"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Task = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
const look_up_entity_1 = require("./look-up.entity");
const user_1 = require("./user");
const opportunity_entity_1 = require("./opportunity.entity");
const task_document_map_entity_1 = require("./task-document-map.entity");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
let Task = class Task {
    constructor(taskName, activityId, companyId, opportunityId, assigneeId, dueDate, taskStatusLid, taskTypeLid, taskClose, taskIsEditable, priorityLid, description) {
        this.taskName = taskName;
        this.activityId = activityId;
        this.companyId = companyId;
        this.opportunityId = opportunityId;
        this.assigneeId = assigneeId;
        this.dueDate = dueDate;
        this.taskStatusLid = taskStatusLid;
        this.taskTypeLid = taskTypeLid;
        this.taskClose = taskClose;
        this.taskIsEditable = taskIsEditable;
        this.priorityLid = priorityLid;
        this.description = description;
    }
};
exports.Task = Task;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "task_name", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], Task.prototype, "taskName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "assignee_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "assigneeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "due_date", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Task.prototype, "dueDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "task_status_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "taskStatusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "task_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "taskTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "task_close", type: "varchar", length: 20, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Task.prototype, "taskClose", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "task_is_editable",
        type: "varchar",
        length: 20,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Task.prototype, "taskIsEditable", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "priority_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "priorityLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Task.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Task.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Task.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({
        name: "deleted_at",
        type: "timestamptz",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Task.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Task.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], Task.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_1.User, (user) => user.userId, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "assignee_id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], Task.prototype, "assignee", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _h : Object)
], Task.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_activity_map_entity_1.OpportunityActivityMap),
    (0, typeorm_1.JoinColumn)({ name: "activity_id" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _j : Object)
], Task.prototype, "activity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "task_status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_k = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _k : Object)
], Task.prototype, "taskStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "task_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_l = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _l : Object)
], Task.prototype, "taskType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "priority_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_m = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _m : Object)
], Task.prototype, "priority", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => task_document_map_entity_1.TaskDocumentMap, (taskDoc) => taskDoc.task),
    tslib_1.__metadata("design:type", Array)
], Task.prototype, "taskDocs", void 0);
exports.Task = Task = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "task" }),
    tslib_1.__metadata("design:paramtypes", [String, Number, Number, Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, Number, Number, String, String, Number, String])
], Task);
